<div class="footer-container">
  <div class="footer-content">
    <!-- ©Mondelēz International.  -->
    {{ currentYear }} © EY Supply Chain Management
  </div>
</div>
